import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

const initialState = {
  creators: [],
  currentCreator: null,
  loading: false,
  error: null,
};

// Async thunks for creator operations
export const fetchCreators = createAsyncThunk(
  'creators/fetchCreators',
  async (_, { rejectWithValue }) => {
    try {
      const creators = await apiService.getAllCreators();
      return creators;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchCreatorById = createAsyncThunk(
  'creators/fetchCreatorById',
  async (creatorId, { rejectWithValue }) => {
    try {
      const creator = await apiService.getCreator(creatorId);
      return creator;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const creatorsSlice = createSlice({
  name: 'creators',
  initialState,
  reducers: {
    setCreators: (state, action) => {
      state.creators = action.payload;
    },
    setCurrentCreator: (state, action) => {
      state.currentCreator = action.payload;
    },
    updateCreator: (state, action) => {
      const index = state.creators.findIndex(c => c.id === action.payload.id);
      if (index !== -1) {
        state.creators[index] = { ...state.creators[index], ...action.payload };
      }
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Creators
      .addCase(fetchCreators.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCreators.fulfilled, (state, action) => {
        state.loading = false;
        state.creators = action.payload;
      })
      .addCase(fetchCreators.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Creator By ID
      .addCase(fetchCreatorById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCreatorById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentCreator = action.payload;
      })
      .addCase(fetchCreatorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { 
  setCreators, 
  setCurrentCreator, 
  updateCreator,
  clearError 
} = creatorsSlice.actions;

export default creatorsSlice.reducer;